<template>
  <div class="container">
    <h1>API 测试页面</h1>
    <div class="info">
      <p><strong>当前环境:</strong> {{ environment }}</p>
      <p><strong>API 基础URL:</strong> {{ baseURL }}</p>
    </div>
    
    <button @click="testApi" :disabled="loading">
      {{ loading ? '测试中...' : '测试 API 连接' }}
    </button>
    
    <div class="result" v-if="result">
      <h3>测试结果</h3>
      <pre>{{ result }}</pre>
    </div>
    
    <div class="error" v-if="error">
      <h3>错误信息</h3>
      <pre>{{ error }}</pre>
    </div>
    
    <div class="troubleshooting" v-if="error">
      <h3>故障排除建议</h3>
      <ul>
        <li v-if="environment === 'production'">检查 Nginx 配置中的 /proxy-api/ 代理设置是否正确</li>
        <li v-if="environment === 'production'">确认后端服务地址 http://47.109.159.145:8998 是否可访问</li>
        <li>检查网络连接和防火墙设置</li>
        <li v-if="environment === 'production'">确保环境变量 VUE_APP_BASE_API 设置正确</li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'ApiTest',
  data() {
    return {
      loading: false,
      result: null,
      error: null,
      environment: process.env.NODE_ENV || 'development',
      baseURL: api.defaults.baseURL || '未设置'
    };
  },
  methods: {
    async testApi() {
      this.loading = true;
      this.result = null;
      this.error = null;
      
      try {
        console.log('发送测试请求到:', '/yisheng/detect-client');
        const response = await api.get('/yisheng/detect-client');
        this.result = JSON.stringify(response.data, null, 2);
      } catch (err) {
        console.error('API 测试失败:', err);
        this.error = {
          message: err.message,
          code: err.code,
          response: err.response ? {
            status: err.response.status,
            data: err.response.data
          } : null
        };
        this.error = JSON.stringify(this.error, null, 2);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
.info {
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
}
button {
  background-color: #007bff;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin: 10px 0;
}
button:hover {
  background-color: #0056b3;
}
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.result, .error {
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
}
.result {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
.troubleshooting {
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #856404;
}
pre {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 15px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>